// src/data/menuData.js

export const menuData = [
  { 
    title: 'Inicio', 
    path: '/' 
  },
  {
    title: 'Autoridades GLP',
    submenus: [
      { title: 'Gran Maestro', path: '/autoridades/gran-maestro' },
      { title: 'Gran Cuadro', path: '/autoridades/gran-cuadro' },
    ],
  },
  {
    title: 'Nosotros',
    submenus: [
      { title: 'Historia', path: '/nosotros/historia' },
      { title: 'Antiguos Linderos', path: '/nosotros/antiguos-linderos' },
      { title: 'Masones Gobernantes', path: '/nosotros/masones-gobernantes' },
    ],
  },
  {
    title: 'Organismos',
    submenus: [
      { title: 'Tribunal Superior de Justicia', path: '/organismos/tribunal-superior-de-justicia' },
      { 
        title: 'Gran Biblioteca', 
        path: '/organismos/gran-biblioteca',
        nested: [
          { title: 'Presentación', path: '/organismos/gran-biblioteca/presentacion' }
        ]
      },
      { 
        title: 'Instituto Histórico', 
        path: '/organismos/instituto-historico',
        nested: [
          { title: 'Presentación', path: '/organismos/instituto-historico/presentacion' },
          { title: 'MUSEO: Estandartes', path: '/organismos/instituto-historico/museo/estandartes' },
          { title: 'MUSEO: Mandiles', path: '/organismos/instituto-historico/museo/mandiles' },
          { title: 'MUSEO: Medallas', path: '/organismos/instituto-historico/museo/medallas' },
          { title: 'MUSEO: Enseres', path: '/organismos/instituto-historico/museo/enseres' },
          { title: 'Archivo Histórico', path: '/organismos/instituto-historico/archivo-historico' },
        ]
      },
      { title: 'Jurado Electoral', path: '/organismos/jurado-electoral' },
      { title: 'FOPREMAS', path: '/organismos/fopremas' },
      { title: 'Publicaciones', path: '/publicaciones' },
    ],
  },
  {
    title: 'Instrucción',
    submenus: [
      { title: 'Cámaras de VV.·.MM.·.II.·.', path: '/instruccion/camaras-vv-mm-ii' },
      { title: 'Consejo del Simbolismo del R.·.E.·.A.·.A.·.', path: '/instruccion/consejo-simbolismo' },
      { 
        title: 'ADAEM', 
        path: '/instruccion/adaem',
        nested: [
          { title: 'Presentación', path: '/instruccion/adaem/presentacion' },
          { title: 'Plan de Docencia', path: '/instruccion/adaem/plan-de-docencia' }
        ]
      },
    ],
  },
  {
    title: 'Logias',
    submenus: [
      { title: 'Logias GLP', path: '/logias/logias-glp' },
      { title: 'Otros Altares', path: '/logias/otros-altares' },
    ],
  },
  {
    title: 'Despacho',
    submenus: [
      { title: 'Decretos', path: '/despacho/decretos' },
      { title: 'Resoluciones', path: '/despacho/resoluciones' },
      { title: 'J.·. E.·. A.·.', path: '/despacho/jea' },
      { title: 'Gran Secretario', path: '/despacho/gran-secretario' },
      { title: 'Gran Tesorería', path: '/despacho/gran-tesoreria' },
      { title: 'Tribunal de Justicia', path: '/despacho/tribunal-de-justicia' },
      { 
        title: 'Candidatos y HH.·.', 
        path: '/despacho/candidatos',
        nested: [
          { title: 'Relación de Profanos', path: '/despacho/candidatos/relacion-profanos' },
          { title: 'Reg.·. Extra.·.', path: '/despacho/candidatos/reg-extra' },
          { title: 'Afil.·. Extra.·.', path: '/despacho/candidatos/afil-extra' }
        ]
      },
    ],
  },
  { 
    title: 'INTRANET', 
    path: '/intranet', 
    isButton: true 
  },
];